<template>
    <div data-aos="fade-down" data-aos-duration="1000"
        class="bg-neutral-800 w-full h-auto px-20 py-10 mt-10 text-white">

        <!-- Mobile: collapsible -->
        <div class="block lg:hidden ">
            <details class="border-b border-gray-700 py-2">
                <summary class="flex items-center justify-between cursor-pointer text-lg">
                    Why Citi
                    <i class="bi bi-chevron-down"></i>
                </summary>
                <ul class="pl-4 mt-2 text-sm space-y-1">
                    <li><a href="#">Our Story</a></li>
                    <li><a href="#">Careers</a></li>
                    <li><a href="#">Benefits and Services</a></li>
                    <li><a href="#">Rewards</a></li>
                    <li><a href="#">Citi Entertainment®</a></li>
                    <li><a href="#">Special Offers</a></li>
                </ul>
            </details>

            <details class="border-b border-gray-700 py-2">
                <summary class="flex items-center justify-between cursor-pointer text-lg">
                    Wealth Management
                    <i class="bi bi-chevron-down"></i>
                </summary>
                <ul class="pl-4 mt-2 text-sm space-y-1">
                    <li><a href="#">Citigold® Private cent</a></li>
                    <li><a href="#">Citigold</a></li>
                    <li><a href="#">Citi Priority</a></li>
                    <li><a href="#">Citi Private Bank</a></li>
                </ul>
            </details>

            <details class="border-b border-gray-700 py-2">
                <summary class="flex items-center justify-between cursor-pointer text-lg">
                    Business Banking
                    <i class="bi bi-chevron-down"></i>
                </summary>
                <ul class="pl-4 mt-2 text-sm space-y-1">
                    <li><a href="#">Small Business Accounts</a></li>
                    <li><a href="#">Commercial Accounts</a></li>
                </ul>
            </details>

            <details class="border-b border-gray-700 py-2">
                <summary class="flex items-center justify-between cursor-pointer text-lg">
                    Rates
                    <i class="bi bi-chevron-down"></i>
                </summary>
                <ul class="pl-4 mt-2 text-sm space-y-1">
                    <li><a href="#">Personal Banking</a></li>
                    <li><a href="#">Credit Cards</a></li>
                    <li><a href="#">Mortgage</a></li>
                    <li><a href="#">Home Equity</a></li>
                    <li><a href="#">Personal Loans</a></li>
                </ul>
            </details>

            <details class="border-b border-gray-700 py-2">
                <summary class="flex items-center justify-between cursor-pointer text-lg">
                    Help & Support
                    <i class="bi bi-chevron-down"></i>
                </summary>
                <ul class="pl-4 mt-2 text-sm space-y-1">
                    <li><a href="#">Contact Us</a></li>
                    <li><a href="#">Help & FAQS</a></li>
                    <li><a href="#">Security Center</a></li>
                </ul>
            </details>

            <!-- Add more sections as needed -->
        </div>

        <!-- Desktop: always shown, no icons -->
        <div class="hidden lg:flex lg:flex-col gap-4">
            <div class="grid md:grid-cols-6 justify-items-stretch">
                <div>
                    <h2 class="text-lg font-semibold mb-2">Why Citi</h2>
                    <ul class="text-sm space-y-1">
                        <li><a href="#">Our Story</a></li>
                        <li><a href="#">Careers</a></li>
                        <li><a href="#">Benefits and Services</a></li>
                        <li><a href="#">Rewards</a></li>
                        <li><a href="#">Citi Entertainment®</a></li>
                        <li><a href="#">Special Offers</a></li>
                    </ul>
                </div>

                <div>
                    <h2 class="text-lg font-semibold mb-2">Wealth Management</h2>
                    <ul class="text-sm space-y-1">
                        <li><a href="#">Citigold Private Client</a></li>
                        <li><a href="#">Citigold</a></li>
                        <li><a href="#">Citi Priority</a></li>
                        <li><a href="#">Citi Private Bank</a></li>
                    </ul>
                </div>
                <div>
                    <h2 class="text-lg font-semibold mb-2">Business Banking</h2>
                    <ul class="text-sm space-y-1">
                        <li><a href="#">Small Business Accounts</a></li>
                        <li><a href="#">Commercial Accounts</a></li>
                    </ul>
                </div>

                <div>
                    <h2 class="text-lg font-semibold mb-2">Rates</h2>
                    <ul class="text-sm space-y-1">
                        <li><a href="#">Personal Banking</a></li>
                        <li><a href="#">Credit Cards</a></li>
                        <li><a href="#">Mortgage</a></li>
                        <li><a href="#">Home Equity</a></li>
                        <li><a href="#">Personal Loans</a></li>
                    </ul>
                </div>

                <div>
                    <h2 class="text-lg font-semibold mb-2">Help & Support</h2>
                    <ul class="text-sm space-y-1">
                        <li><a href="#">Contact Us</a></li>
                        <li><a href="#">Help & FAQS</a></li>
                        <li><a href="#">Security Center</a></li>
                    </ul>
                </div>

                <div>
                    <i class="bi bi-box-arrow-in-up text-white text-3xl"></i>
                </div>
                <!-- Add more sections -->
            </div>
        </div>
        <div class="flex flex-col lg:flex-row justify-between mt-10">
            <div class="lg:hidden">
                <i class="bi bi-box-arrow-in-up text-white text-3xl"></i>
            </div>

            <div>
                <h1 class="text-gray-300 mt-3 lg:mt-10">Google play</h1>
            </div>
            <div class="flex flex-row gap-4 mt-10">
                <i class="bi bi-facebook text-4xl"></i>
                <i class="bi bi-twitter-x text-4xl "></i>
                <i class="bi bi-youtube text-4xl"></i>
            </div>
        </div>
        <hr class="border-t border-gray-300 my-4 " />
        <div class="flex flex-col lg:flex-row mt-2 gap-5">
            <h1 class="text-white font-bold">© 2025 Citigroup Inc</h1>
            <h1 class="text-white font-normal hover:underline">Terms and Conditions</h1>
            <h1 class="text-white font-normal hover:underline">Privacy</h1>
            <h1 class="text-white font-normal hover:underline">Notice at Collection</h1>
            <h1 class="text-white font-normal hover:underline">Do Not Sell Or Share My Personal Information</h1>
            <h1 class="text-white font-normal hover:underline">Accessibility</h1>
        </div>
        <hr class="border-t  border-gray-300 my-4 hidden lg:block" />
        <div class="flex flex-col gap-5 mt-10">
            <h1 class="text-white font-bold">Important Legal Disclosures & Information</h1>
            <h1 class="text-white font-normal ">Citibank.com provides information about and access to accounts and
                financial services provided by Citibank, N.A. and its affiliates in the United States and its
                territories. It does not, and should not be construed as, an offer, invitation or solicitation of
                services to individuals outside of the United States.</h1>
            <h1 class="text-white font-normal ">Terms, conditions and fees for accounts, products, programs and
                services are subject to change. Not all accounts, products, and services as well as pricing
                described here are available in all jurisdictions or to all customers. Your eligibility for a
                particular product and service is subject to a final determination by Citibank. Your country of
                citizenship, domicile, or residence, if other than the United States, may have laws, rules, and
                regulations that govern or affect your application for and use of our accounts, products and
                services, including laws and regulations regarding taxes, exchange and/or capital controls that you
                are responsible for following.</h1>
            <h1 class="text-white font-normal ">The products, account packages, promotional offers and services
                described in this website may not apply to customers of International Personal Bank U.S. in the
                Citigold® Private Client International, Citigold® International, Citi International Personal, Citi
                Global Executive Preferred, and Citi Global Executive Account Packages.</h1>
            <h1 class="text-white font-normal ">Deposit products and services are offered by Citibank, N.A., Member
                FDIC</h1>
        </div>

        <div class="flex flex-row justify-between mt-7 relative">
            <img src="https://online.citi.com/CBOL/IA/Angular/assets/citiredesign-footer.svg" alt="">

        </div>
           <!-- feedback box  -->
    <div class="fixed z-50 bottom-2 right-2 bg-gray-500 rounded-tl-lg px-4 py-2 flex items-center gap-2 shadow-lg">
        <i class="bi bi-rss text-white"></i>
        <h1 class="text-white text-sm">Feedback</h1>
    </div>
    </div>

</template>

<script setup>

</script>

<style scoped></style>